export const PROGRAM_STRUCTURE_4_CONSTANTS = {
  PROGRAM_STRUCTURE_4_FIELDS_CONFIG: [
    {
      fieldName: "section_background_image",
      label: "Section background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload full-bleed background",
      required: false,
      defaultValue: "",
      filterCategory: "images",
    },
    {
      fieldName: "section_background_image_alt",
      label: "Background image alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "section_overlay_rgba",
      label: "Image overlay (RGBA, optional)",
      value: "rgba(0,0,0,0.55)",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leave empty for no overlay, or e.g. rgba(0,0,0,0.45)",
      required: false,
      defaultValue: "rgba(0,0,0,0.55)",
    },
    {
      fieldName: "headline_primary",
      label: "Headline (wrap highlighted words in { })",
      value: "Program {Structure}",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder:
        "Wrap highlighted words in { } — e.g. Program {Structure}. Use {{...}} to push the highlight onto its own line.",
      required: false,
      defaultValue: "Program {Structure}",
      rows: 2,
    },
    {
      fieldName: "headline_primary_color",
      label: "Headline base color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "headline_accent",
      label: "Headline (accent line, optional)",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Optional second line shown in the accent color",
      required: false,
      defaultValue: "",
      rows: 2,
    },
    {
      fieldName: "headline_accent_color",
      label: "Headline highlight color ({ } words)",
      value: "#F5C542",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#F5C542",
    },
    {
      fieldName: "topics_column_title",
      label: "Subjects panel heading (optional)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. List of Subjects",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "subjects_column_label",
      label: "Subjects column header",
      value: "Subjects",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Left column header — leave empty to hide",
      required: false,
      defaultValue: "Subjects",
    },
    {
      fieldName: "credits_column_label",
      label: "Credits column header",
      value: "Credits",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Right column header — shows only when subjects have credits",
      required: false,
      defaultValue: "Credits",
    },
    {
      fieldName: "electives_tab_label",
      label: "Electives tab name",
      value: "Elective Courses",
      valueType: "string",
      filedType: "INPUT",
      placeholder:
        "Tab shown when any subject row has an elective group, e.g. Elective Courses",
      required: false,
      defaultValue: "Elective Courses",
    },
    {
      fieldName: "electives_semester_label",
      label: "Electives — right column header",
      value: "Semester",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Header for the elective subject's semester column",
      required: false,
      defaultValue: "Semester",
    },
    {
      fieldName: "electives_empty_message",
      label: "Electives — empty state message",
      value: "There are no subjects in this elective",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Shown when a selected elective has no subjects",
      required: false,
      defaultValue: "There are no subjects in this elective",
    },
    {
      fieldName: "card_background_color",
      label: "Main card background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "module_list_track_background_color",
      label: "Desktop — semester list panel background",
      value: "#E8EAED",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#E8EAED",
    },
    {
      fieldName: "content_panel_background_color",
      label: "Subjects box background",
      value: "#F3F4F6",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#F3F4F6",
    },
    {
      fieldName: "module_inactive_border_color",
      label: "Semester row border / subject divider",
      value: "#E5E7EB",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#E5E7EB",
    },
    {
      fieldName: "module_list_divider_color",
      label: "Divider line between semesters (left column)",
      value: "#94A3B8",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#94A3B8",
    },
    {
      fieldName: "module_active_background_color",
      label: "Selected semester background",
      value: "#FF6B00",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FF6B00",
    },
    {
      fieldName: "module_active_text_color",
      label: "Selected semester text",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "module_inactive_text_color",
      label: "Semester text (inactive)",
      value: "#111827",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#111827",
    },
    {
      fieldName: "section_background_color",
      label: "Fallback background (when no image)",
      value: "#0B0F14",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#0B0F14",
    },
    {
      fieldName: "cta_button_text",
      label: "CTA label",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_button_text_color",
      label: "CTA text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_button_color",
      label: "CTA background",
      value: "#FF6B00",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FF6B00",
    },
    {
      fieldName: "cta_button_is_cta",
      label: "Is CTA — Primary (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = lead capture popup; off = direct course brochure URL (needs brochure on course)",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "brochure_cta_text",
      label: "Download brochure — label (empty = hide)",
      value: "Download Brochure",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "Download Brochure",
    },
    {
      fieldName: "brochure_cta_text_color",
      label: "Download brochure — text & icon",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "brochure_cta_border_color",
      label: "Download brochure — border",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "brochure_cta_is_cta",
      label: "Is CTA — Download brochure (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = lead capture popup then download; off = open course brochure URL directly",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_TITLES: {
    metadata: "Semester subjects",
  },

  METADATA_FIELDS: [
    {
      header: "Semester / tab name",
      fieldName: "semester_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Semester 1",
      required: false,
    },
    {
      header: "Semester subtitle (optional)",
      fieldName: "semester_subtitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. As per elective — shown under the semester name",
      required: false,
    },
    {
      header: "Subject name",
      fieldName: "subject_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Foundations of Management",
      required: false,
    },
    {
      header: "Subject logo / image (optional)",
      fieldName: "subject_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Badge / partner logo shown next to the subject",
      required: false,
      filterCategory: "images",
    },
    {
      header: "Subject image alt text",
      fieldName: "subject_image_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the subject logo",
      required: false,
    },
    {
      header: "Credits (optional)",
      fieldName: "credits",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 4 — leave empty to hide the credits column",
      required: false,
    },
    {
      header: "Elective group (optional)",
      fieldName: "elective_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder:
        "Set to move this subject under the Electives tab, e.g. Marketing Specialization",
      required: false,
    },
    {
      header: "Subject's semester (electives only)",
      fieldName: "subject_semester",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Semester shown for this elective subject, e.g. Semester 3",
      required: false,
    },
    {
      header: "Sort order",
      fieldName: "priority",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "0",
      required: false,
      defaultValue: 0,
    },
    {
      header: "Active",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: true,
    },
  ],

  DEFAULT_ROW: {
    semester_name: "",
    semester_subtitle: "",
    subject_name: "",
    subject_image: "",
    subject_image_alt: "",
    credits: "",
    elective_name: "",
    subject_semester: "",
    priority: 0,
    status: true,
  },
};
